import { Directive, forwardRef } from '@angular/core';
import type { Validator } from '@angular/forms';
import { AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[muiVisibleText][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => MuiVisibleTextValidator), multi: true }]
})
/**
 * @deprecated no clear use case, and it does not work anyway for all expected patterns
 */
export class MuiVisibleTextValidator implements Validator {
  protected static regex = /\S+/;
  protected static validationError: ValidationErrors = { notVisible: true };

  static validate(c: AbstractControl): null | ValidationErrors {
    const str = c.value as string;

    if (MuiVisibleTextValidator.regex.test(str)) {
      return null;
    } else {
      return MuiVisibleTextValidator.validationError;
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return MuiVisibleTextValidator.validate(control);
  }
}
